import React from "react";
import i18n from "../../../../i18n/i18n";
import AddItem from "../../../../common/components/shared/addItem/addItem";
import PortForm from "../portForm/portForm";

export default class AddPort extends React.Component {
    render() {
        return (
            <AddItem
                class="add-port"
                header={i18n.t("dictionaries.ports.actions.addPort.header")}
                content={<PortForm isUpdate={false} />}
            />
        );
    }
}